"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarIntegrationSettingsSchema () {
        return CalendarIntegrationSettingsSchema;
    },
    get CalendarIntegrationSettingsSchemaWithDefault () {
        return CalendarIntegrationSettingsSchemaWithDefault;
    },
    get MeetingsIntegrationsSettingsSchema () {
        return MeetingsIntegrationsSettingsSchema;
    },
    get VideoConferencingConnectionSchema () {
        return VideoConferencingConnectionSchema;
    },
    get VideoConferencingProviderEnum () {
        return VideoConferencingProviderEnum;
    },
    get VideoConferencingSettingsSchema () {
        return VideoConferencingSettingsSchema;
    },
    get VideoConferencingSettingsSchemaWithDefault () {
        return VideoConferencingSettingsSchemaWithDefault;
    }
});
const _zod = require("zod");
const CalendarIntegrationSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const CalendarIntegrationSettingsSchemaWithDefault = _zod.z.object({
    enabled: _zod.z.boolean().default(false)
});
const VideoConferencingSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const VideoConferencingSettingsSchemaWithDefault = _zod.z.object({
    enabled: _zod.z.boolean().default(false)
});
const VideoConferencingProviderEnum = _zod.z.enum([
    "zoom"
]);
const VideoConferencingConnectionSchema = _zod.z.object({
    provider: VideoConferencingProviderEnum,
    connectedAt: _zod.z.date(),
    accountEmail: _zod.z.string().nullable(),
    tokenExpired: _zod.z.boolean()
});
const MeetingsIntegrationsSettingsSchema = _zod.z.object({
    calendar: CalendarIntegrationSettingsSchema.optional(),
    video_conferencing: VideoConferencingSettingsSchema.optional()
});
